import FirebaseRegister from '../ui/FirebaseRegister';
import { connect } from 'react-redux';
import { registerUser, backToAddress, nextPage, registerFirebaseUser } from '../../actions';

const mapStateToProps = (state, props) =>
  ({
    page: state.page,
    territory: state.territory,
    content: state.content,
    environment: state.environment,
    territory_code: state.territory.code,
    requiredFields: state.requiredFields,
    enableFirebaseAuthentication: state.territory.enable_firebase_authentication,
    email: props.email,
    password: props.password
  });

const mapDispatchToProps = dispatch =>
  ({
    onRegisterFirebaseUser(payload) {
      dispatch(
        registerFirebaseUser(payload)
      )
    }
  });

const Container = connect(mapStateToProps, mapDispatchToProps)(FirebaseRegister);

export default Container;
